module.exports = __webpack_public_path__ + "static/media/banner.02565a36.jpg";